/**
 * Chip de status documental por loja (pior → melhor).
 * Usa resumo do paciente + liberação daquela organizationId.
 * @module storeDocumentStatusChip
 */

import {
  isDispenseReleaseCurrentlyValid,
  purchaseReleaseMemory,
} from "../../purchase-release";

export type StoreDocumentOpState =
  | "docs_pending"
  | "docs_rejected"
  | "docs_to_approve"
  | "awaiting_release"
  | "docs_released";

const CHIP: Record<
  StoreDocumentOpState,
  { label: string; color: "default" | "info" | "success" | "warning" | "error" }
> = {
  docs_pending: { label: "Documentos pendentes", color: "warning" },
  docs_rejected: { label: "Documento recusado", color: "error" },
  docs_to_approve: { label: "Aguardando aprovação", color: "info" },
  awaiting_release: { label: "Aguardando liberação", color: "info" },
  docs_released: { label: "Disponível", color: "success" },
};

export function peekStoreHasValidRelease(
  patientKey: string,
  organizationId?: string,
): boolean {
  const key = patientKey.trim();
  const orgId = organizationId?.trim();
  if (!key) return false;
  const batches = purchaseReleaseMemory.get(key) ?? [];
  return batches.some((batch) => {
    if (orgId && batch.organizationId !== orgId && batch.storeId !== orgId) {
      return false;
    }
    return batch.dispenses.some((dispense) =>
      isDispenseReleaseCurrentlyValid(dispense),
    );
  });
}

export interface ResolveStoreDocumentOpStateParams {
  missingDocuments: boolean;
  hasRejected: boolean;
  awaitingApproval: boolean;
  hasValidRelease: boolean;
}

/** Prioridade pior → melhor (chip da loja). */
export function resolveStoreDocumentOpState(
  params: ResolveStoreDocumentOpStateParams,
): StoreDocumentOpState {
  if (params.missingDocuments) return "docs_pending";
  if (params.hasRejected) return "docs_rejected";
  if (params.awaitingApproval) return "docs_to_approve";
  if (params.hasValidRelease) return "docs_released";
  return "awaiting_release";
}

export function getStoreDocumentStatusChip(state: StoreDocumentOpState) {
  return CHIP[state];
}
